// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__x3bxT","close-panel":"Modal_close-panel__Jib8i","modal-content":"Modal_modal-content__s1JQJ","modal-body":"Modal_modal-body__CJgJM"};